import BasicServer from '~/services/BasicServer'
import { NetCode } from '~/types/const'
import store from '~/store'
import type { IHomePageConfig, ILanguage } from '~/services/BasicServer/types'
import { decryptDataSensitive } from '@/utils'

export interface languageModel {
    code: string;
    name: string;
    lock: boolean;
}

const useBasicStore = defineStore('basic', () => {
    const homePageConfig = ref<IHomePageConfig>({} as IHomePageConfig)
    const visitorCountryCode = ref('')
    const isVisitorInChina = computed(() => visitorCountryCode.value.toUpperCase() === 'CN')
    /** @deprecated 仅保留一个发布周期；站点能力请改用 useSiteConfig。 */
    const isChina = computed(() => isVisitorInChina.value)
    const languages = ref<ILanguage[]>([])
    const commonLanguages = ref<string[]>([])
    const languagesMap = ref<Record<string, ILanguage>>({})
    /** @deprecated 拼写错误的兼容别名；新代码使用 visitorCountryCode。 */
    const localtionData = visitorCountryCode
    const sensitiveWords = ref<string[]>([])
    async function getHomePageConfig() {
        const res = await BasicServer.getHomePageConfig()
        if(res.code === NetCode.SUCCESS){
            await nextTick()
            homePageConfig.value = res.data as IHomePageConfig
        }
    }
     // 敏感词
     function getSensitiveWords(){
        BasicServer.getRequestSensitiveWords().then((result)=>{
            if (result && result.code == '1'){
                let data = decryptDataSensitive(result.data)
                console.log("getRequestSensitiveWords", data)
                if (data){
                    sensitiveWords.value = data.toString().split(',')
                }
            }
        })
    }
    async function getLanguages() {
        const res = await BasicServer.getLanguages()
        if(res.code === NetCode.SUCCESS){
            await nextTick()
            let lan = (navigator.browserLanguage || navigator.language)
            let lanCode = findKey(convertLanguage, lan) || 'en'
            let newList: [languageModel] = res.data.langList
            let currentObject = null
            for (let i = 0; i < newList.length; i++) {
                let language = newList[i]
                if (language.code == lanCode && !language.lock) {
                    // @ts-ignore
                    currentObject = language
                    newList.splice(i, 1)
                    break
                }
            }
            if (currentObject) {
                newList.unshift(currentObject)
            }
            languages.value = res.data.langList as ILanguage[]
            commonLanguages.value = res.data.userLangList || []
            let maps = {}
            for (let index = 0; index < languages.value.length; index++) {
                const element = languages.value[index];
                maps[element.code] = element
            }
            languagesMap.value = maps
        }
    }
    function setVisitorCountry(data?: string) {
        visitorCountryCode.value = (data || '').toUpperCase()
    }
    /** @deprecated 拼写错误的兼容方法；新代码使用 setVisitorCountry。 */
    function setLocaltion(data?: string) {
        setVisitorCountry(data)
    }
    return {
        homePageConfig,
        getHomePageConfig,
        isChina,
        isVisitorInChina,
        visitorCountryCode,
        languages,
        commonLanguages,
        languagesMap,
        getLanguages,
        localtionData,
        setVisitorCountry,
        setLocaltion,
        getSensitiveWords,
        sensitiveWords
    }
})

export function useBasicStoreHook() {
    return useBasicStore(store)
}
export default useBasicStore
